import React from 'react';
import { ThreeDots } from 'react-loader-spinner';
import { useSelector } from 'react-redux';

import styles from './GlobalLoader.module.scss';

const GlobalLoader = () => {
  const globalLoading = useSelector((state) => state.globalReducer.loading);

  return (
    globalLoading && (
      <div className={styles.globalLoader}>
        <ThreeDots height="60" width="60" radius="9" color="#4fa94d" ariaLabel="three-dots-loading" visible />
      </div>
    )
  );
};

export default GlobalLoader;
